import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { MPagination } from "../../../../helper/pagination";
import {
  CommentCategory,
  LabDocumentModel,
  MComment,
  Product,
  ProductInquiry,
  ProductUI,
} from "../entity/product.model";

async function getProducts(
  inquiry: ProductInquiry
): Promise<MPagination<ProductUI>> {
  let pagination: MPagination<ProductUI> = await api.get(
    `${mConstants.ORDER_URL}/products`,
    { params: inquiry }
  );

  pagination.results.forEach((product) => {
    product.label = product.name;
    product.value = product.uuid;
  });

  return pagination;
}

async function getProduct(productId: string): Promise<ProductUI> {
  let product: ProductUI = await api.get(
    `${mConstants.ORDER_URL}/products/${productId}`
  );

  product.label = product.name;
  product.value = product.uuid;

  return product;
}

function editProduct(product: Product): Promise<void> {
  return api.put(`${mConstants.ORDER_URL}/products`, product);
}

function getProductComments(
  productId: string,
  categoryId: string
): Promise<MComment[]> {
  return api.get(`${mConstants.ORDER_URL}/products/${productId}/comments`, {
    params: { categoryId },
  });
}

function getCommentsCategories(
  type: "product" | "customer"
): Promise<CommentCategory[]> {
  return api.get(`${mConstants.ORDER_URL}/comments/categories/${type}`);
}

function addDocument(
  productId: string,
  document: LabDocumentModel
): Promise<LabDocumentModel> {
  return api.post(
    `${mConstants.ORDER_URL}/products/${productId}/documents`,
    document
  );
}

function deleteDocument(documentId: string): Promise<void> {
  return api.delete(`${mConstants.ORDER_URL}/products/documents/${documentId}`);
}

export const productService = {
  getProducts,
  getProduct,
  editProduct,
  addDocument,
  deleteDocument,
  getProductComments,
  getCommentsCategories,
};
